<template>
    <div>
        <div class="el-flex">
         <el-button type="primary"  plain icon="el-icon-search" @click="getFluxPollListHandler($event)" >查 询</el-button>
         <el-button type="primary" @click="addProgramme">新增方案（根据自然月使用的真实流量）</el-button>
        </div>
        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		  height="651" >
          <el-table-column prop="name" label="规则名称" align="center"></el-table-column>
            <el-table-column prop="limitStateName" label="规则状态" align="center"></el-table-column>
			<el-table-column prop="createName" label="创建人" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                     <el-link :underline="false" type="primary" @click="editData(scope.row)">编辑</el-link>
                     <el-link :underline="false" type="primary" @click="delData(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <!---方案弹窗-->
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="programmeDialog" width="600px" :close-on-click-modal="false">
            <el-form ref="limitForm" :model="dataForm"  label-width="120px"  :rules="rules">
                <el-form-item label="规则名称:" prop="name">
                    <el-input v-model="dataForm.name" placeholder="请输入规则名称" clearable></el-input>
                </el-form-item>
               
                <el-form-item label="规则状态：" prop="limitState" clearable>
                    <el-select v-model="dataForm.limitState"  >
                        <el-option v-for="item in limitStateArr" :key="item.code" :value="item.code" :label="item.label"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="虚量规则：" prop="limitDatalist">
                  <div style="font-size:12px;color:red;">请按照使用量从小到大排序</div>
                    <template v-if="dataForm.limitDatalist">
                        <el-row v-for="(k,index) in dataForm.limitDatalist" :key="index" style="margin-bottom:10px">
                            <el-col :span="10"  style="padding-right:5px;">
                                <el-input v-model="k.useData" placeholder="使用流量/G" clearable @input="change($event)"/>
                            </el-col>
                            <el-col :span="10" style="padding-right:5px;">
                                <el-input v-if="dataForm.supplierType === '9'" v-model="k.limitValue" placeholder="可使用流量比（%）" clearable @input="change($event)"/>
                                <el-select v-model="k.limitValue" v-if="dataForm.supplierType === '3'" clearable @input="change($event)">
                                    <el-option v-for="item in autoSubArr" :key="item.code" :value="item.code" :label="item.label"></el-option>
                                </el-select> 
                                <el-select v-model="k.limitValue" v-if="dataForm.supplierType === '6'" clearable @input="change($event)">
                                    <el-option v-for="item in autoSubArr1" :key="item.code" :value="item.code" :label="item.label"></el-option>
                                </el-select> 
                                <el-select v-model="k.limitValue" v-if="dataForm.supplierType === '5'" clearable @input="change($event)">
                                    <el-option v-for="item in autoSubArr2" :key="item.code" :value="item.code" :label="item.label"></el-option>
                                </el-select> 
                                <el-select v-model="k.limitValue" v-if="dataForm.supplierType === '1'" clearable @input="change($event)">
                                    <el-option v-for="item in autoSubArr3" :key="item.code" :value="item.code" :label="item.label"></el-option>
                                </el-select> 
                            </el-col>
                            <el-col :span="4">
                                <el-button type="danger" @click="delRule(index)">删除</el-button>
                            </el-col>
                        </el-row>
                    </template> 
                    <el-button type="primary" @click="addRule">新增规则</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close()">取 消</el-button>
                <el-button type="primary" @click="sumbit()">提 交</el-button>
            </div> 
        </el-dialog>
        <!--白名单弹窗-->
        <el-dialog :append-to-body="true" title="白名单" :visible.sync="whiteShow" width="600px" :close-on-click-modal="false">
            <el-input v-model="querd.iccid" placeholder="请输入iccid" clearable style="width:200px;margin-right:10px;"></el-input>
            <el-button type="default" @click="searct">查询</el-button>
            <el-button type="primary" @click="addCard">添加卡号</el-button>
            <el-button type="danger" @click="delCard">删除卡号</el-button>
            <el-table :data="dialog.tableData"
                border
                fit
                highlight-current-row
                style="width: 100%;margin:10px 0;"
                :header-cell-style="{background:'#f5f5f5'}"
                height="400"
                >
                    <el-table-column prop="id" label="id" align="center"></el-table-column>
                    <el-table-column prop="iccid" label="显示卡号" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="delDialogData(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="dialog.currentPage1"
                    :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
                    :page-size="dialog.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dialog.total">
                </el-pagination>
        </el-dialog>
        <!---新增白名单-->
        <el-dialog :append-to-body="true" :title="title1" :visible.sync="addWhiteShow" width="600px" :close-on-click-modal="false">
            <el-input v-model="iccidStrs" placeholder="请输入请输入1个或多个卡号,多个请用逗号、空格、或者换行分隔" :rows="10" type="textarea" clearable style="margin-right:10px;" />
            <div style="margin-top:10px">
                <el-button type="default" @click="addSumbit" v-if="title1==='新增白名单'">确定添加</el-button>
                <el-button type="default" @click="addDelete" v-if="title1==='删除白名单'">确定删除</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {supplierListPages,supplierListAdds ,supplierListUpdates,supplierListDeletes,supplierOutPage,supplierOutBatch,supplierOutDelete,supplierOutDelete1} from '@/api/sim.js'
    import common from '@/utils/common.js'
    export default {
        data(){
            return{
                supplierTypeArr:[
                    {label:'中国电信',code:'1'},
                    {label:'中国移动',code:'3'},
                    {label:'DCP电信',code:'5'},
                    {label:'电信5G',code:'6'},
                    {label:'中国联通',code:'9'}
                ],
                limitTypeArr:[
                    {label:'按月限速',code:'0'},
                    {label:'按日限速',code:'1'}
                ],
                limitStateArr:[
                    {label:'开启',code:'0'},
                    {label:'关闭',code:'1'}
                ],
                //中国移动
                autoSubArr:[
                    {label:'速率恢复',code:'1'},
                    {label:'APN-AMBR=2Mbps（月初不自动恢复）',code:'91'},
                    {label:'APN-AMBR=1Mbps（月初不自动恢复）',code:'92'},
                    {label:'APN-AMBR=512Kbps（月初不自动恢复）',code:'93'},
                    {label:'APN-AMBR=128Kbps（月初不自动恢复）',code:'94'},
                    {label:'APN-AMBR=2Mbps（月初自动恢复）',code:'95'},
                    {label:'APN-AMBR=1Mbps（月初自动恢复）',code:'96'},
                    {label:'APN-AMBR=512Kbps（月初自动恢复）',code:'97'},
                    {label:'APN-AMBR=128Kbps（月初自动恢复）',code:'98'}
                ],
                //电信5G
                autoSubArr1:[
                    {label:'解除限速',code:'10'},
                    {label:'512Kbps',code:'11'},
                    {label:'1Mbps',code:'12'},
                    {label:'3Mbps',code:'13'},
                    {label:'5Mbps',code:'14'},
                    {label:'7Mbps',code:'15'},
                    {label:'70Mbps',code:'22'}
                ],
                //DCP电信
                autoSubArr2:[
                    {label:'解除限速',code:'0'},
                    {label:'DCP电信限速1Mbps',code:'5'},
                    {label:'DCP电信限速5Mbps',code:'7'},
                    {label:'DCP电信限速7Mbps',code:'8'},
                    {label:'DCP电信限速10Mbps',code:'9'}
                ],
                //中国电信
                autoSubArr3:[
                    {label:'解除限速',code:'10'},
                    {label:'512Kbps',code:'11'},
                    {label:'1Mbps',code:'12'},
                    {label:'3Mbps',code:'13'},
                    {label:'5Mbps',code:'14'},
                    {label:'10Mbps',code:'16'},
                    {label:'20Mbps',code:'17'}
                ],
                tbpg: {
                    tableData: [],
                    currentPage: 1,
                    pageSize: 15,
                    total: 0
                },
                dialog:{
                    tableData: [],
                    currentPage: 1,
                    pageSize: 15,
                    total: 0
                },
                dataForm:{
                    name:'',
                    supplierType:'9',
                    limitType:'0',
                    limitState:'',
                    autoSub:'',
                    limitDatalist:[]
                },
                rules: {
                    name: [
                        { required: true, message: '请输入规则名称', trigger: 'blur' },
                    ],
                    supplierType: [
                        { required: true, message: '请选择运营商类型', trigger: 'blur' },
                    ],
                    limitType: [
                        { required: true, message: '请选择限速类别', trigger: 'blur' },
                    ],
                    limitState: [
                        { required: true, message: '请选择限速状态', trigger: 'blur' },
                    ],
                },
                title:'',
                title1:'',
                programmeDialog:false,
                whiteShow:false,
                querd:{
                    iccid:''
                },
                iccidStrs:'',
                addWhiteShow:false,
            }
        },
        created(){
            this.getFluxPollListHandler();
        },
        methods:{
            change(e) {
                this.$forceUpdate()
            },
            getFluxPollListHandler($event){
                common.resetCurrentPage(this, $event, 'tbpg');
                var data = common.getRequestParams(this, 'tbpg',{});
                supplierListPages(data).then(res => {
                    common.listCallback(this, res, 'tbpg');
                })
            },
            handleSizeChange(val){
                this.tbpg.pageSize = val;
                this.getFluxPollListHandler();
            },

            handleCurrentChange(val){
                this.tbpg.currentPage = val;
                this.getFluxPollListHandler();
            },
            handleSizeChange1(val){
                this.dialog.pageSize = val;
                this.getDialogData();
            },

            handleCurrentChange1(val){
                this.dialog.currentPage = val;
                this.getDialogData();
            },
            getDialogData($event){
                common.resetCurrentPage(this, $event, 'dialog');
                var data = common.getRequestParams(this, 'dialog',this.querd);
                supplierOutPage(data).then(res => {
                    common.listCallback(this, res, 'dialog');
                })
            },
            searct(){
                this.getDialogData()
            },
            //新增
            addProgramme(){
                this.title="新增"
                this.programmeDialog = true
            },
            //编辑
            editData(data){
                this.title="编辑"
                this.programmeDialog = true
                this.dataForm = JSON.parse(JSON.stringify(data))
                this.dataForm.limitState = String(this.dataForm.limitState)
                this.dataForm.limitType = String(this.dataForm.limitType)
                this.dataForm.limitDatalist = JSON.parse(this.dataForm.limitData)
                this.dataForm.supplierType = String(this.dataForm.supplierType)
                console.log(this.dataForm)
            },
            supplierTypeChange(){
                this.dataForm.autoSub = ''
                this.dataForm.limitDatalist.map(item=>item.limitValue = '')
            },
            close(){
                this.$refs['limitForm'].resetFields();
                this.dataForm.id = ''
                this.programmeDialog = false
            },
            //弹窗新增规则
            addRule(){
                this.dataForm.limitDatalist.push({
                    useData:'',
                    limitValue:''
                })
                this.$forceUpdate()
            },
            //弹窗删除规则
            delRule(i){ 
                this.dataForm.limitDatalist = this.dataForm.limitDatalist.filter((item,index) => index !== i)  
                this.$forceUpdate()
            },
            //保存
            sumbit(){
                this.$refs['limitForm'].validate((valid) => {
                    if (valid) {
                        var size = this.dataForm.limitDatalist.length > 0 ? this.dataForm.limitDatalist.filter(item=>!item.useData || !item.limitValue) : []
                        if(this.dataForm.limitDatalist.length === 0 || size.length > 0){
                            this.$message.error('限速规则有未填项，请补充完整后提交');
                            return
                        }
                        if(this.dataForm.id){
                            supplierListUpdates(this.dataForm).then(res=>{
                                if(res.data.code == 200){
                                    this.$message.success('操作成功');
                                    this.getFluxPollListHandler()
                                    this.close()
                                }else{
                                    this.$message.error(res.data.message);
                                }
                            })
                        }else{
                            supplierListAdds(this.dataForm).then(res=>{
                                if(res.data.code == 200){
                                    this.$message.success('操作成功');
                                    this.getFluxPollListHandler()
                                    this.close()
                                }else{
                                    this.$message.error(res.data.message);
                                }
                            })
                        }
                    }
                })
            },
            //删除数据
            delData(data){
                this.$confirm("确定要删除该数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierListDeletes({id:data.id}).then(res=>{
                        if(res.data.code == 200){
                            this.$message.success('操作成功');
                            this.getFluxPollListHandler()
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //白名单
            whiteClick(){
                this.whiteShow=true
                this.getDialogData()
            },
            addCard(){
                this.iccidStrs = ''
                this.title1="新增白名单"
                this.addWhiteShow = true
            },
            delCard(){
                this.iccidStrs = ''
                this.title1="删除白名单"
                this.addWhiteShow = true
            },
            //批量新增
            addSumbit(){
                this.$confirm("确定要新增数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutBatch({iccidStrs:this.iccidStrs}).then(res=>{
                        if(res.data.code == 200){
                            this.addWhiteShow = false
                            this.getDialogData()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //批量删除
            addDelete(){
                this.$confirm("确定要删除数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutDelete({iccidStrs:this.iccidStrs}).then(res=>{
                        if(res.data.code == 200){
                            this.addWhiteShow = false
                            this.getDialogData()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //单个删除
            delDialogData(data){
                this.$confirm("确定要删除该数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutDelete1({id:data.id}).then(res=>{
                        if(res.data.code == 200){
                            this.$message.success('操作成功');
                            this.getDialogData()
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            }
        }
    }
</script>
<style lang="less">
    .el-flex{
        display: flex;
        justify-content: end;
        margin-bottom:10px;
    }
    .el-link--primary{
        margin-right:10px;
    }
</style>